"use client";
import { CentiLogo } from "@/components";
import ErrorPage from "@/components/organisms/error";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <div className="p-6">
      <CentiLogo />
      <ErrorPage error={error} />;
    </div>
  );
}
